import React from "react";
import { ManageSourceCompensationContainer } from "../../../containers";

const ManageSourceCompensation = (props) => {
  return <ManageSourceCompensationContainer {...props} />;
};

export default ManageSourceCompensation;
